import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import { init as initFullStory } from "@fullstory/browser";

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter(routes);

if (
  process.env.REACT_APP_ENVIRONMENT === "production" &&
  process.env.REACT_APP_FULL_STORY_ORG_ID
) {
  initFullStory({ orgId: process.env.REACT_APP_FULL_STORY_ORG_ID });
}

root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
